import * as React from "react";
import { connect } from "react-redux";
import fileSaver from "file-saver";
import PropTypes from "prop-types";
import * as storage from "../../coraWebComponents/utils/storage";
import withRouter from "../../coraWebComponents/utils/withRouter";
import "./User.scss";

// cora web components
import Dialog from "../../coraWebComponents/dialogs/Dialog";
import Slide from "../../coraWebComponents/animation/Slide";
import ManualPDF from "../../coraWebComponents/navigation/ManualPDF";
import BadgeContainer from "../../coraWebComponents/BadgeContainer";

// actions
import * as filesActions from "../../actions/filesActions";
import * as spravyActions from "../../actions/spravyActions";

// Prop types
import userPropTypes from "../../propTypes/userPropTypes";

// Routes
import Routes from "../../constants/Routes";

import { getMeno } from "../../utils/userUtils";

class User extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showInfo: false,
      showNotifikacie: false,
      isManualDialogOpen: false,
      isConfirmDialogOpen: false,
    };
  }

  handleSettings = () => { };
  handleInitIcon = () => this.props.navigate(Routes.INFO_USER);
  handleNapoveda = () => { };
  handleSpravy = () => this.props.navigate(Routes.SPRAVY);
  handleInfo = () => {
    this.setState({
      showInfo: true,
    });
  };
  handleCloseInfo = () => {
    this.setState({ showInfo: false });
  };
  handleManualDialogClose = () => {
    this.setState({
      isManualDialogOpen: false,
    });
  };
  handleConfirmDialogDownload = async () => {
    this.setState({
      isConfirmDialogOpen: false,
    });

    await this.props.getUserManual();

    const { userManualBlob, userManualFileName } = this.props;
    if (userManualBlob) fileSaver.saveAs(userManualBlob, userManualFileName);
  };
  handleConfirmDialogZobrazit = () => {
    this.setState({
      isConfirmDialogOpen: false,
      isManualDialogOpen: true,
    });
  };
  handleConfirmDialogClose = () => {
    this.setState({
      isConfirmDialogOpen: false,
      isManualDialogOpen: false,
    });
  };
  handleToS = () => {
    this.setState({ isConfirmDialogOpen: true });
  };
  handleNotifikacie = () => {
    this.setState({
      showNotifikacie: true,
    });
  };
  handleCloseNotifikacie = () => {
    this.setState({ showNotifikacie: false });
  };
  handleLogout = () => {
    storage.removeUser();
    this.props.onSignOut();
  };
  genChildren = () => {
    const { user, getUserManual, userManualBlob, userManualFileName } = this.props;

    return (
      <ManualPDF
        manualProps={{
          hasList: false,
          user,
          manualBlob: userManualBlob,
          manualFileName: userManualFileName,
          manualTitle: "ZISPortal_prirucka",
        }}
        getManual={getUserManual}
      />
    );
  };

  buildInicialy = () => {
    const { uzivatel } = this.props;

    if (!uzivatel) {
      return "x";
    }

    if (uzivatel.PRIEZVISKO && uzivatel.MENO) {
      return uzivatel.PRIEZVISKO.charAt(0) + uzivatel.MENO.charAt(0);
    }

    return getMeno(uzivatel).charAt(0);
  };
  componentDidMount() {
    this.props.getCountNeprecitaneSpravy(-1);
  }

  render() {
    const {
      showInfo,
      showNotifikacie,
      isManualDialogOpen,
      isConfirmDialogOpen,
    } = this.state;
    const { countNeprecitaneSpravy, user, uzivatel } = this.props;

    const infoOkno = (
      <div className="info-okno">
        <div className="nav_initials">
          <div className="inicialization-icone" onClick={this.handleInitIcon}>
            {this.buildInicialy()}
          </div>
        </div>

        <div className="example-2">
          {uzivatel && (
            <div className="meno-user">
              <section>
                <p><strong>{getMeno(uzivatel)}</strong></p>
                {uzivatel.EMAIL && <p>{uzivatel.EMAIL || "e-mail"}</p>}
                {uzivatel.MOBIL && <p>{uzivatel.MOBIL || "telefon"}</p>}
              </section>
            </div>
          )}
          {this.props.userInfo}
        </div>

        <div className="nav_button_logout">
          <div className="ToS" onClick={this.handleToS}>
            <p>Príručka</p>
          </div>
          <div className="logout" onClick={this.handleLogout}>
            Odhlásiť sa
          </div>
        </div>
      </div>
    );

    const notifikacieOkno = (
      <div className="info-okno">Notifikácie Placeholder</div>
    );
    return (
      <>
        <div className="nav-user">
          {/* <div>
            <img
              onClick={() => props.navigate(Routes.HOME)}
              src={logoURL}
              alt="Logo"
            />
          </div> */}

          <div className="firstContainer">
            <div className="prihlasenyWeb">
              {user ? user.Uzivatel.N_UZ : "Prázdne meno"}
            </div>

            <BadgeContainer
              align={{ vertical: "top", horizontal: "start" }}
              className={
                countNeprecitaneSpravy !== 0 ? "" : "hide-badge-container"
              }
              size="small"
              shape="pill"
              cutoutBorder={true}
              content={countNeprecitaneSpravy}
            >
              <div className="k-icon k-font-icon k-i-envelop" onClick={this.handleSpravy} />
            </BadgeContainer>
            <div className="k-icon k-font-icon k-i-info" onClick={this.handleNapoveda} />
            <div className="k-icon k-font-icon k-i-user" onClick={this.handleInfo} />

            <Slide
              isOpen={showNotifikacie}
              onClose={this.handleCloseNotifikacie}
            >
              {notifikacieOkno}
            </Slide>
            <Slide isOpen={showInfo} onClose={this.handleCloseInfo}>
              {infoOkno}
            </Slide>
          </div>
          <div className="secondContainer">
            <div className="prihlasenyMobile">
              {user?.Uzivatel?.N_UZ || "Prázdne meno"}
            </div>
          </div>
        </div>

        <Dialog
          isOpen={isConfirmDialogOpen}
          onCancel={this.handleConfirmDialogZobrazit}
          onClose={this.handleConfirmDialogClose}
          onConfirm={this.handleConfirmDialogDownload}
          title="Prajete si dokument stiahnuť ?"
          confirmText="Stiahnuť"
          cancelText="Zobraziť"
          children={<></>}
        />
        <Dialog
          isOpen={isManualDialogOpen}
          title={"Používateľská príručka"}
          onClose={this.handleManualDialogClose}
          onConfirm={this.handleManualDialogClose}
          fullscreen={true}
          className={"fullscreen-report"}
          children={this.genChildren()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countNeprecitaneSpravy: state.countNeprecitaneSpravy.data,
    isLoading: state.files.isLoading,
    userManualBlob: state.files.userManual?.blob || null,
    userManualFileName: state.files.userManual?.fileName || "ZISPortal_prirucka.pdf",
    user: state.user.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCountNeprecitaneSpravy: (I_ORGAN) =>
    dispatch(spravyActions.getCountNeprecitaneSpravy(I_ORGAN)),
  getUserManual: () => dispatch(filesActions.getUserManual()),
});

User.propTypes = {
  countNeprecitaneSpravy: PropTypes.number,
  getCountNeprecitaneSpravy: PropTypes.func,
  getUserManual: PropTypes.func,
  isLoading: PropTypes.bool,
  userManual: PropTypes.element,
  userManualBlob: PropTypes.object,
  userManualFileName: PropTypes.string,
  onSignOut: PropTypes.func.isRequired,
  user: userPropTypes.user,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(User));
